<template>
  <div class="sy-info">
    <!-- //用户反馈 -->
    <el-row class="t-header">
      <el-col :span="4">发送人</el-col>
      <el-col :span="8">消息内容</el-col>
      <el-col :span="4">发送时间</el-col>
      <el-col :span="4">状态</el-col>
      <el-col :span="4">操作</el-col>
    </el-row>
    <el-row class="content" v-if="resultData.list&&resultData.list.length>0" v-loading="tableLoading">
      <el-row class="content-item" v-for="(item,index) in resultData.list" :key="index">
        <el-row class="info">
          <el-col :span="4">{{item.title?item.title:'暂无'}}</el-col>
          <el-col :span="8">{{item.msg_introduction}}</el-col>
          <el-col :span="4">{{item.created_at}}</el-col>
          <el-col :span="4">
            <span v-show="item.state==1">已发送</span>
            <span v-show="item.state==2">已查看</span>
          </el-col>
          <el-col :span="4" class="blue cp">
            <!-- <span @click="privateMessage(item,'2')">编辑</span> -->
            <span class="" @click="recallMessage(reBackUserMessage(),{msg_id:item.msg_id},initSyMessage)">撤回</span></el-col>
        </el-row>
      </el-row>
    </el-row>

    <div class="tc mt40">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="Number(resultData.page)"
        :page-size="Number(resultData.size)"
        layout="total, prev, pager, next"
        :total="Number(resultData.count)"
      ></el-pagination>
    </div>
    
     <!-- 修饰符传参，可以通过子组件的方法更新值的状态或者值 -->
    <PrivateMessage :privateVisible.sync="privateVisible" :private_info="private_info" :messageType="messageType"></PrivateMessage>
  </div>
</template>

<script>
//引入消息组件
import PrivateMessage from '../components/private-message'

//引入混合mixins模式
import user_mixins from '../components/user-mixins'

import {_reBackUserMessage,_UserSyMessageEdit,_userSyMessage} from '@/api/user-message'

export default {
  created() {
    this.initSyMessage();
  },
  props:{
    user_id:{
      type:String
    }
  },
  mixins: [user_mixins],
  components: {
    PrivateMessage
  },
  data() {
    return {
      search: {
        page:1,
        size:10,
      },
      tableLoading:false,
      
      resultData: {
        data: [
          {
            person: "推广员系统消息",
            time: "2019-05-29 18:22:48",
            content: "恭喜你喜你成为【智东西公开课】的推广员，推广成功可赚佣金",
            status:"0",
            power:"1",
          },
        ],
        count: "100"
      }
    };
  },
  methods: {
    //查询信息
    seachList() {
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.initSyMessage()
    },
    reply(item) {
      this.privateDialogVisible = true;
    },
    //加载系统消息
    initSyMessage(){
      this.tableLoading=true;
      _userSyMessage({
          params:{
          page:this.search.page,
          size:this.search.size,
          user_id:this.user_id
        }
      }).then(res=>{
      this.tableLoading=false;
         if (res.resultCode == 1) {
          // console.log(res);
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      })
    },
    reBackUserMessage(){
      return _reBackUserMessage
    }
  }
};
</script>

<style scoped lang="less">
.sy-info {
  .t-header {
    margin-top: 20px;
    background-color: @table-bg;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
  }
  .content {
    .content-item {
      .info {
        height: 60px;
        line-height: 60px;
        padding: 0 10px;
        font-weight: 500;
        overflow: hidden;
        }
      &:nth-child(2n){
      background-color: #fefefe;
      }
      &:hover{
      background-color: @table-bg;
      }
    }
  }
}
</style>